import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { AccountCreationHistoryClient } from "../../../../../Wrap/Api/Account/AccountCreationHistory";
import { MonthlyChargeTypesValuationClient } from "../../../../../Wrap/Api/AdviserCharges/MonthlyChargeTypesValuation";
import { AssetUnderManagementClient } from "../../../../../Wrap/Api/Business/AssetUnderManagement";
import { ClientSummaryGroupClient } from "../../../../../Wrap/Api/Business/ClientSummaryGroup";
import { CompanyServicePropositionClient } from "../../../../../Wrap/Api/Company/CompanyServiceProposition";
import { ProductUnderlyingAccountValuationClient } from "../../../../../Wrap/Api/PortfolioValuation/ProductUnderlyingAccountValuation";
import { ProductWrapperValuationClient } from "../../../../../Wrap/Api/PortfolioValuation/ProductWrapperValuation";
import { UserClientSummaryGroupSettingClient } from "../../../../../Wrap/Api/User/UserClientSummaryGroupSetting";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { ExternalTransferStatus } from "../../../../../Wrap/Constants/Enums/Transfer/ExternalTransferStatus";
import { UserClientSummaryGroupSettingModel } from "../../../../../Wrap/Models/Domains/Users/UserClientSummaryGroupSettingModel";
import { IJsonDate } from "../../../../../Wrap/System/IJsonDate";
import { BusinessManagementDispatcher, BusinessManagementPropositionDispatcher } from "../Store/Variable";

export class BusinessManagementAction {
    public static GetCommonData(
        hierarchy: string,
        asAt: IJsonDate,
        startDate: IJsonDate,
        endDate: IJsonDate,
        status: ExternalTransferStatus,
        selectedProposition: ServiceProposition[]
    ) {
        const client = new AssetUnderManagementClient();
        const promise = client.get(hierarchy, asAt, startDate, endDate, status, selectedProposition);
        promise.onSuccess((data) => {
            BusinessManagementDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static getWrapSummary(hierarchyId: string, asAt: Date, selectedProposition: ServiceProposition[], callback) {
        const client = new ProductWrapperValuationClient();
        const promise = client.get(hierarchyId, JsonDateParser.toJsonDateNoOffset(asAt), selectedProposition);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getProductDetailForWrapperSummary(
        hierarchyId,
        asAt,
        subAccountType,
        selectedProposition: ServiceProposition[],
        min,
        max,
        callback
    ) {
        const client = new ProductUnderlyingAccountValuationClient();
        if (subAccountType == SubAccountType.InvestmentAccount) {subAccountType = SubAccountType.PersonalPortfolio;}
        const promise = client.get(
            hierarchyId,
            subAccountType,
            selectedProposition,
            JsonDateParser.toJsonDateNoOffset(asAt),
            min,
            max
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getClientSummary(
        hierarchyId: string,
        asAt: Date,
        selectedProposition: ServiceProposition[],
        callback
    ) {
        const client = new ClientSummaryGroupClient();
        const promise = client.get(hierarchyId, JsonDateParser.toJsonDateNoOffset(asAt), selectedProposition);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static setClientSummary(
        setting: UserClientSummaryGroupSettingModel,
        hierarchyId: string,
        asAt: Date,
        selectedProposition: ServiceProposition[],
        callback
    ) {
        const client = new UserClientSummaryGroupSettingClient();
        const promise = client.post(setting, hierarchyId, JsonDateParser.toJsonDateNoOffset(asAt), selectedProposition);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getNewAccounts(
        hierarchyId: string,
        from: Date,
        to: Date,
        selectedProposition: ServiceProposition[],
        callback
    ) {
        const client = new AccountCreationHistoryClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(from),
            JsonDateParser.toJsonDateNoOffset(to),
            selectedProposition
        );
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getAdviserCharges(
        companyHierarchyId: string,
        adviserHierarchyId: string,
        from: Date,
        to: Date,
        selectedProposition: ServiceProposition[],
        callback
    ) {
        const client = new MonthlyChargeTypesValuationClient();
        const promise = client.get(
            companyHierarchyId,
            adviserHierarchyId,
            JsonDateParser.toJsonDateNoOffset(from),
            JsonDateParser.toJsonDateNoOffset(to),
            selectedProposition
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getCompanyServiceProposition(hierarchyId: string, callback) {
        const client = new CompanyServicePropositionClient();
        const promise = client.get(0, hierarchyId);
        promise.onSuccess((data: Array<ServiceProposition>) => {
            callback(data);
            BusinessManagementPropositionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }
}
